<script setup lang="ts">
import InputNumber from '@/components/BaseComponents/InputNumber.vue';
import type { Ingredient } from '@/types/dish';
import Checkbox from 'primevue/checkbox';
import { defineEmits, type ModelRef } from 'vue';
import { useI18n } from 'vue-i18n';

const ingredient: ModelRef<Ingredient> = defineModel('ingredient', { type: Object as () => Ingredient, required: true });
const emit = defineEmits(['toggle']);
const { t, te } = useI18n();

const toggleIngredientSelection = (ingredient) => {
  emit('toggle', ingredient);
};
</script>

<template>
  <div class="mb-4 flex w-full gap-3 border-b border-primary-500 pb-1 text-sm text-primary-950">
    <div class="flex w-3 flex-none items-center">
      <Checkbox
        v-model="ingredient.is_selected"
        :input-id="`checkbox-${ingredient.id}`"
        :binary="true"
        @click.prevent="() => toggleIngredientSelection(ingredient)"
      />
    </div>
    <label :for="`checkbox-${ingredient.id}`" class="flex min-w-0 flex-1 gap-1">
      <div class="w-24 flex-none">
        <div class="flex items-center gap-1 text-left">
          <InputNumber
            v-model="ingredient.quantity"
            :placeholder="t('profileFavorites.creationForm.quantityPlaceholder')"
            class="w-16 flex-none"
            mode="decimal"
          />
          <span class="flex-1">
            {{ te(`ingredients.unit.symbol.${ingredient.unit}`) ? t(`ingredients.unit.symbol.${ingredient.unit}`) : '' }}
          </span>
        </div>
      </div>
      <div class="flex h-full min-w-0 flex-1 items-center">
        <span class="truncate">{{ ingredient.name }}</span>
      </div>
      <div class="flex w-10 flex-none items-center">
        <span>{{ ingredient.price }}</span>
      </div>
    </label>
  </div>
</template>
